const matIntelligenceReasoning = [
  {
    id: 31,
    question: "Find the next number in the series: 3, 8, 15, 24, 35, ?",
    options: ["A. 46", "B. 48", "C. 50", "D. 52"],
    answer: "B"
  },
  {
    id: 32,
    question:
      "Statements: All pens are books. All books are tables.\nConclusions:\nI. All pens are tables.\nII. Some tables are pens.",
    options: [
      "A. Only conclusion I follows",
      "B. Only conclusion II follows",
      "C. Both conclusions follow",
      "D. Neither conclusion follows"
    ],
    answer: "C"
  },
  {
    id: 33,
    question: "In a certain code, 'GARDEN' is written as 'HBSEFO'. How is 'FLOWER' written in that code?",
    options: ["A. GMPXFS", "B. GMPXFT", "C. GMQXFS", "D. FMPXFS"],
    answer: "A"
  },
  {
    id: 34,
    question:
      "Ravi is Meena's brother. Suresh is Meena's father. Anita is Suresh's mother. How is Ravi related to Anita?",
    options: ["A. Grandson", "B. Son", "C. Nephew", "D. Grandfather"],
    answer: "A"
  },
  {
    id: 35,
    question:
      "Five friends P, Q, R, S, T sit in a row facing north. R sits second from the left. S sits immediately right of R. P sits at one of the extreme ends. Who sits at the other extreme end?",
    options: ["A. Q", "B. T", "C. S", "D. Cannot be determined"],
    answer: "D"
  },
  {
    id: 36,
    question: "Find the odd one out: 8, 27, 64, 100, 125",
    options: ["A. 8", "B. 27", "C. 100", "D. 125"],
    answer: "C"
  },
  {
    id: 37,
    question:
      "A is the son of B. C is the mother of A. D is the brother of C. How is D related to B?",
    options: ["A. Brother-in-law", "B. Father", "C. Uncle", "D. Cannot be determined"],
    answer: "A"
  },
  {
    id: 38,
    question:
      "If 'TRAIN' is coded as 'UQBHO', what does 'PLANE' get coded as using the same logic?",
    options: ["A. QKBMF", "B. QKBOF", "C. QMBOF", "D. QKBMD"],
    answer: "A"
  },
  {
    id: 39,
    question: "Find the next number in the series: 5, 11, 23, 47, 95, ?",
    options: ["A. 189", "B. 190", "C. 191", "D. 192"],
    answer: "C"
  },
  {
    id: 40,
    question:
      "In a certain language, 'MONTH' is coded as 'NPOUI'. How is 'WEIGHT' coded in the same language?",
    options: ["A. XFJHIU", "B. XGJHIU", "C. XFJHIV", "D. XFJIHU"],
    answer: "A"
  },
  {
    id: 41,
    question:
      "Pointing to a photograph, a man said, 'She is the daughter of my grandfather's only son.' How is the woman in the photograph related to the man (assume the man is not an only child)?",
    options: ["A. Daughter", "B. Sister", "C. Mother", "D. Niece"],
    answer: "B"
  },
  {
    id: 42,
    question:
      "Six people A, B, C, D, E, F sit in a row facing north. B sits third from the left. E sits immediately right of B. A sits at the extreme right end. D sits second from the right. C sits immediately left of B. Who sits at the extreme left end?",
    options: ["A. C", "B. D", "C. F", "D. Cannot be determined"],
    answer: "C"
  },
  {
    id: 43,
    question:
      "Rahul walks 10m north, then turns right and walks 5m, then turns right again and walks 10m. How far is he from the starting point?",
    options: ["A. 5m", "B. 10m", "C. 15m", "D. 20m"],
    answer: "A"
  },
  {
    id: 44,
    question: "Doctor : Hospital :: Teacher : ?",
    options: ["A. Student", "B. School", "C. Book", "D. Classroom"],
    answer: "B"
  },
  {
    id: 45,
    question: "Pen : Write :: Knife : ?",
    options: ["A. Cut", "B. Sharp", "C. Kitchen", "D. Blade"],
    answer: "A"
  },
  {
    id: 46,
    question: "Find the odd one out: Triangle, Square, Circle, Rectangle, Pentagon",
    options: ["A. Triangle", "B. Square", "C. Circle", "D. Pentagon"],
    answer: "C"
  },
  {
    id: 47,
    question:
      "Statements: Some cats are dogs. All dogs are animals.\nConclusions:\nI. Some cats are animals.\nII. All animals are dogs.",
    options: [
      "A. Only conclusion I follows",
      "B. Only conclusion II follows",
      "C. Both conclusions follow",
      "D. Neither conclusion follows"
    ],
    answer: "A"
  },
  {
    id: 48,
    question: "If A=1, B=2, C=3 ... Z=26, what is the sum of the letter values in the word 'CAT'?",
    options: ["A. 20", "B. 22", "C. 24", "D. 26"],
    answer: "C"
  },
  {
    id: 49,
    question: "Find the missing letter in the series: A, C, F, J, O, ?",
    options: ["A. T", "B. U", "C. V", "D. W"],
    answer: "B"
  },
  {
    id: 50,
    question: "In a class of 40 students, Raj ranks 15th from the top. What is his rank from the bottom?",
    options: ["A. 24", "B. 25", "C. 26", "D. 27"],
    answer: "C"
  },
  {
    id: 51,
    question:
      "Pointing to a man, a woman said, 'His mother is the only daughter of my mother.' How is the woman related to the man?",
    options: ["A. Mother", "B. Sister", "C. Aunt", "D. Grandmother"],
    answer: "A"
  },
  {
    id: 52,
    question:
      "Statement: The government has announced free public transport for a week to reduce traffic congestion.\nAssumptions:\nI. Free fares may encourage more people to use public transport.\nII. Traffic congestion is caused entirely by private vehicles.",
    options: [
      "A. Only assumption I is implicit",
      "B. Only assumption II is implicit",
      "C. Both assumptions are implicit",
      "D. Neither assumption is implicit"
    ],
    answer: "A"
  },
  {
    id: 53,
    question:
      "Four friends A, B, C, D sit around a circular table facing the center. A sits to the immediate right of B. C sits opposite A. Who sits opposite B?",
    options: ["A. C", "B. D", "C. A", "D. Cannot be determined"],
    answer: "B"
  },
  {
    id: 54,
    question:
      "In a certain language, 'RIVER' is coded as 'SJWFS'. How is 'STONE' coded in the same language?",
    options: ["A. TUPOF", "B. TUPOG", "C. TVPOF", "D. TUQOF"],
    answer: "A"
  },
  {
    id: 55,
    question:
      "A family consists of a father, a mother, their two sons, and the sons' wives. What is the minimum number of people in the family, and how are the sons' wives related to the mother?",
    options: [
      "A. 6 members; daughters",
      "B. 6 members; daughters-in-law",
      "C. 4 members; daughters-in-law",
      "D. 8 members; daughters-in-law"
    ],
    answer: "B"
  },
  {
    id: 56,
    question: "Find the next number in the series: 2, 6, 12, 20, 30, ?",
    options: ["A. 36", "B. 40", "C. 42", "D. 44"],
    answer: "C"
  },
  {
    id: 57,
    question: "Author : Book :: Sculptor : ?",
    options: ["A. Chisel", "B. Statue", "C. Museum", "D. Stone"],
    answer: "B"
  },
  {
    id: 58,
    question:
      "A man starts from his house, walks 6 km east, then turns south and walks 8 km. How far is he from his starting point?",
    options: ["A. 8 km", "B. 10 km", "C. 12 km", "D. 14 km"],
    answer: "B"
  },
  {
    id: 59,
    question:
      "Statements: All students are hardworking. Some hardworking people are successful.\nConclusions:\nI. Some students are successful.\nII. All hardworking people are students.",
    options: [
      "A. Only conclusion I follows",
      "B. Only conclusion II follows",
      "C. Both conclusions follow",
      "D. Neither conclusion follows"
    ],
    answer: "D"
  },
  {
    id: 60,
    question: "If in a code, 'CHAIR' is written as 'DIBJS', how would 'TABLE' be written?",
    options: ["A. UBCMF", "B. UBCLF", "C. UCCMF", "D. UBCMG"],
    answer: "A"
  }
];

export default matIntelligenceReasoning;